import styled from 'styled-components';

import Button from '~/src/common/components/Button';
import { ButtonContent, InnerButton } from '~/src/common/components/Button/layout';
import { media } from '~/src/styles-constants';

export const Root = styled.div`
  z-index: 10;
  position: fixed;
  inset: auto 0 0;
  background-color: ${({ theme }) => theme.palette.background};

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 8px calc(env(safe-area-inset-bottom) + 16px) 8px;

  border-top: 1px solid ${({ theme }) => theme.palette.common.BACKGROUND_3};

  ${media.M`
    position: initial;

    border-bottom: 1px solid ${({ theme }) => theme.palette.common.BACKGROUND_3};

    padding: 16px;
  `}
`;

export const PortionsText = styled.p`
  margin: 0 8px;

  & > span:first-child {
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
  }

  & > span:last-child {
    margin-left: 4px;
    font-size: 12px;
    line-height: 16px;
  }
`;

export const AddToCartButton = styled(Button)`
  height: 40px;

  ${InnerButton} > ${ButtonContent} {
    padding: 0 8px;
  }
`;
